import React, { Component } from "react";
import axios from "axios";
import { toast } from "react-toastify";

import { BACKEND_CONFIG } from "../config/consts";
import requestExcessSurplusIcon from "../images/policy-actions-icons/icon-refresh-circle-arrows.png";

import ChevronLink from "./actions-panel/ChevronLink";

class ExcessSurplusAction extends Component {
  constructor(props) {
    super(props);

    this.state = {
      requested: this.props.excessSurplusQuotesRequested,
    };
  }
  render() {
    return (
      <ChevronLink
        to={"#"}
        disabled={this.state.requested}
        onClick={(e) => this.requestExcessSurplusQuotes(this.props.clientId)}
        icon={requestExcessSurplusIcon}
      >
        {this.props.displayMessage}
      </ChevronLink>
    );
  }

  requestExcessSurplusQuotes(clientId) {
    if (!this.state.requested) {
      axios
        .post(
          `${BACKEND_CONFIG.apiUrl}client/${clientId}/requestexcesssurplussuspense`
        )
        .then(({ data }) => {
          toast.success("Request was submitted.", {
            position: toast.POSITION.TOP_RIGHT,
          });
          this.setState({ requested: true });
        })
        .catch(() => {
          toast.error("There was an error submitting your request.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        });
    }
  }
}

export default ExcessSurplusAction;
